import { render, staticRenderFns } from "./TakePhotoCopper.vue?vue&type=template&id=427a66da&scoped=true"
import script from "./TakePhotoCopper.vue?vue&type=script&lang=js"
export * from "./TakePhotoCopper.vue?vue&type=script&lang=js"
import style0 from "./TakePhotoCopper.vue?vue&type=style&index=0&id=427a66da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427a66da",
  null
  
)

export default component.exports